var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/builds/natuurhuisje/nature.house/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/website/partials/chatChannel.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<aside\n    class=\"nh-chat-channel\"\n    data-endpoint=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "action_path"), env.opts.autoescape);
output += "\"\n    ";
frame = frame.push();
var t_3 = env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "data"));
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_1;
if(runtime.isArray(t_3)) {
var t_2 = t_3.length;
for(t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1][0];
frame.set("[object Object]", t_3[t_1][0]);
var t_5 = t_3[t_1][1];
frame.set("[object Object]", t_3[t_1][1]);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "=\"";
output += runtime.suppressValue(t_5, env.opts.autoescape);
output += "\"";
;
}
} else {
t_1 = -1;
var t_2 = runtime.keys(t_3).length;
for(var t_6 in t_3) {
t_1++;
var t_7 = t_3[t_6];
frame.set("name", t_6);
frame.set("value", t_7);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += runtime.suppressValue(t_6, env.opts.autoescape);
output += "=\"";
output += runtime.suppressValue(t_7, env.opts.autoescape);
output += "\"";
;
}
}
}
frame = frame.pop();
output += "\n>\n    <div class=\"nh-chat-channel__chat-info\">\n        <strong class=\"nh-chat-channel__name\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "username"), env.opts.autoescape);
output += "</strong>\n        <time class=\"nh-chat-channel__date\" datetime=\"\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "last_message_at"), env.opts.autoescape);
output += "</time>\n    </div>\n\n    <div class=\"nh-chat-channel__chat-info\">\n        <strong class=\"nh-chat-channel__title\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</strong>\n        <p class=\"nh-chat-channel__message\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "message"), env.opts.autoescape);
output += "</p>\n    </div>\n\n    <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "channel_path"), env.opts.autoescape);
output += "\" class=\"nh-chat-channel__reply nh-button nh-button--link\">\n        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "reply"), env.opts.autoescape);
output += "\n    </a>\n\n    <button type=\"button\" data-role=\"archive\" class=\"nh-chat-channel__archive nh-button nh-button--link\">\n        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "action"), env.opts.autoescape);
output += "\n    </button>\n</aside>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/website/partials/chatChannel.html.njk"] , dependencies)